/**
 * Tipo da pergunta no contrato da API: `QuestionarioPergunta.tipo` só aceita
 * os códigos "A" (alternativa), "D" (dissertativa) ou "T" (texto) — confirmado
 * via 400 de validação (`Tipo deve ser 'A', 'D' ou 'T'.`) ao enviar o valor de
 * domínio ("Alternativa") direto. O domínio hoje só suporta Alternativa.
 */
export const TIPO_PERGUNTA_ALTERNATIVA_API = 'A';
